import { useEffect } from "react";

const useMathjax = (depedency,depedency1) => {
    useEffect(() => {
        const script = document.createElement('script');
      
        script.src = "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js";
        // script.src = "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.7/MathJax.js?config=TeX-MML-AM_CHTML";
        script.async = true;
      
        script.onload = () => {
          window.MathJax.typeset();
        };
      
        document.body.appendChild(script);
      
        return () => {
          document.body.removeChild(script);
        };
      }, [depedency,depedency1]);
};

export default useMathjax;